import useSWR from 'swr'
import { fetcher } from 'utilities/api'
import { Bundle } from '../../../api/src/bundles/bundle.entity'

export const useBundle = (bundleId?: number | string) => {
  const { data, error } = useSWR<Bundle>(bundleId ? `/bundles/${bundleId}` : null, fetcher)

  return {
    bundle: data,
    isBundleLoading: !error && !data,
    isBundleError: error,
  }
}

export const useBundles = (occasionIds?: number[]) => {
  const { data, error } = useSWR<Bundle[]>(occasionIds ? `/bundles?occasionIds=${occasionIds.join(',')}` : '/bundles', fetcher)

  return {
    bundles: data,
    isBundlesLoading: !error && !data,
    isBundlesError: error,
  }
}
